/* rc-shop.js — jump chips for the shop page.

   The chips scroll to a range; they never hide anything. That is the point:
   the page is already split into named groups with their own copy, so a filter
   that hid two of them would remove the merchandising rather than help.

   Built from the groups present in the DOM, so adding a range in the theme
   editor adds a chip with no edit here.

   The active chip follows the scroll via IntersectionObserver. rootMargin pulls
   the trigger line just under the sticky bar so a chip lights up when its
   section reaches the bar, not the top of the window. */
(function () {
  var BAR_H = 64; // keep in step with .rc-filterbar height + scroll-margin-top

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var host = document.querySelector('[data-rc-chips]');
    var groups = [].slice.call(document.querySelectorAll('[data-rc-group]'));
    if (!host || !groups.length) return;

    var total = document.querySelectorAll('[data-rc-group] [data-cacao]').length;

    var html = '<a class="rc-chip is-active" href="#" data-target="top">All' +
      '<span class="rc-chip__n">' + total + '</span></a>';
    groups.forEach(function (g) {
      var label = (g.getAttribute('data-label') || '').trim();
      var n = g.querySelectorAll('[data-cacao]').length;
      if (!label || !n) return;
      html += '<a class="rc-chip" href="#' + g.id + '" data-target="' + g.id + '">' +
        label + '<span class="rc-chip__n">' + n + '</span></a>';
    });
    html += '<span class="rc-filterbar__count">' + total +
      (total === 1 ? ' product' : ' products') + '</span>';
    host.innerHTML = html;

    var chips = [].slice.call(host.querySelectorAll('.rc-chip'));
    function setActive(id) {
      chips.forEach(function (c) {
        var on = c.getAttribute('data-target') === id;
        c.classList.toggle('is-active', on);
        if (on) c.setAttribute('aria-current', 'true');
        else c.removeAttribute('aria-current');
      });
    }

    chips[0].addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setActive('top');
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) setActive(en.target.id); });
      }, { rootMargin: '-' + BAR_H + 'px 0px -70% 0px', threshold: 0 });
      groups.forEach(function (g) { io.observe(g); });
      window.addEventListener('scroll', function () {
        if (window.scrollY < 40) setActive('top');
      }, { passive: true });
    }
  });
})();
